// Relative path so Node-test environments (which don't resolve the @/ TS alias)
// can import this module — required by routeHelper's `routing.locales` source.
import { LOCALIZED_PATHS } from "../constants/pathnames.js";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["tr", "en", "de", "ar", "az", "ru"],
  defaultLocale: "tr",
  localePrefix: "as-needed",
  pathnames: LOCALIZED_PATHS,
  localeDetection: false,
  alternateLinks: false,
  // localeCookie: false,
});
